import React, { useEffect, useRef } from "react";
import './PublishPanel.css';
import InputBox from "../../components/reusable/InputBox";
import { isClickInBox } from "../../utilities/js/ClickPositionHelper";
import Constants from '../../utilities/js/Constants';


import { isLoggedIn } from "utilities/js/ActionLibrary";


const copyLinkIcon = Constants.ICON_COPY;
const openNewTabIcon = Constants.ICON_NEW_TAB;

const PublishPanel = (props) => {

    const bracketLinkRef = useRef(null);

    useEffect(() => {
        document.addEventListener('click', closePanelOnOutsideClick);
    }, []);

    function closePanelOnOutsideClick(event) {
        let panel = document.querySelector('#publishPanel');
        if (panel) {
            if (!isClickInBox(event.x, event.y, panel.getBoundingClientRect())) {
                props.closePanel(event);
            }
        }
    }

    function createTextArea(text) {
        let textArea = document.createElement('textArea');
        textArea.className = 'hidden';
        textArea.value = text;
        document.body.appendChild(textArea);
        return textArea;
    }

    function copyLink(event) {
        let copyText = createTextArea(bracketLinkRef.current.state.value);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */
        navigator.clipboard.writeText(copyText.value);
        document.body.removeChild(copyText);

        props.showToast('Copied link to clipboard');
    }

    function openLinkInNewTab() {
        var copyText = document.querySelector(".poll-link");
        window.open(copyText.value, '_blank');
    }

    function publishBracket() {
        props.publishBracket();
    }

    function getShareableLinkUI() {
        if (props.bracketId) {
            return (
                <div className="poll-link-display">
                    <div className="poll-detail-header">Share this bracket with friends</div>
                    <div className="poll-detail-subtext">Copy the following link and send it to those you wish to view this bracket</div>

                    <div className="poll-link-form">
                        <InputBox name='poll-link' class='poll-link styled-input' ref={bracketLinkRef} value={Constants.HOST_URL + "/bracket/" + props.bracketId + '/view'} readonly="readonly"></InputBox>
                        <button label='copy-link' className='contact-us-button' onClick={copyLink}><img className="copy-link-icon" alt="copy-link" src={copyLinkIcon}></img></button>
                        <button label='open-link' className='contact-us-button' onClick={openLinkInNewTab}><img className="open-new-tab-icon" alt="open-new-tab" src={openNewTabIcon}></img></button>
                    </div>
                </div>
            );
        }

    }

    function getPublishButton() {
        if (isLoggedIn()) {
            return (
                <div class="settings-button-container">
                    <button id="publish-button" className='nav-button-green' onClick={publishBracket}>Publish Bracket</button>
                </div>
            )
        } else {
            return (
                <>
                    <div class="settings-button-container">
                        <button className='nav-button disabled' disabled>Publish Bracket</button>
                    </div>
                    <div className="publish-login-prompt">You must log in and verify your email to publish new brackets. 
                    {/* Click <button className="login-toggle-button" onClick={props.openAccountPanel}>here</button> to log in */}
                    </div>
                </>
            )
        }
    }

  

    return (
        <div id="publishPanel" className="side-panel">

            <div className="popup-panel-header">
                <div className="popup-header-spacer"></div>
                <div className="popup-panel-heading">Publish Bracket</div>
                <div className="popup-header-spacer"></div>
            </div>
            <div className="side-panel-contents">
                <div className="settings-section">
                    <div className="label-text">
                        You mush publish your bracket to save it for future use or share it with friends
                    </div>
                </div>
                <div className="settings-section">
                    {getShareableLinkUI()}
                    {getPublishButton()}
                </div>
            </div>

            <div class="panel-footer">
                <button className='nav-button' onClick={props.closePanel}>Close</button>
            </div>
        </div>
    );
    
}

export default PublishPanel;
